import { Component, computed, ElementRef, input, viewChild } from '@angular/core';
import { FULL_STAR_SVG, PARTIAL_STAR_SVG } from '../../../assets/svg-constants';
import { SafeHtml } from '../../pipes/SafeHtml.pipe';

@Component({
  standalone: true,
  imports: [SafeHtml],
  selector: 'app-star-rating',
  templateUrl: 'star-rating.component.html',
  styleUrl: 'star-rating.component.scss'
})

export class StarRatingComponent {
  public readonly rating = input.required<number>();
  public readonly ratingCustomClasses = input<string>('');

  public readonly partialStar = viewChild<ElementRef<HTMLSpanElement>>('partialStar');

  public readonly STAR_SVGs = { FULL_STAR_SVG, PARTIAL_STAR_SVG };

  public readonly fullStars = computed(() => Math.trunc(this.rating()));
  public readonly splitStar = computed(() => {
    const rating = this.rating();
    const split = Number((rating - Math.trunc(rating)).toFixed(1)) * 100 + '%';
    this.partialStar()?.nativeElement.querySelector('stop.full-star')?.setAttribute('offset', split);
    this.partialStar()?.nativeElement.querySelector('stop.empty-star')?.setAttribute('offset', split);
    return split;
  });
}